export const messages = {
  en: {
    myAuditOrders: {
      todoList: 'Todo List',
      back: 'Back',
      refresh: 'Refresh',
      orderNumber: 'Order Number',
      orderType: 'Order Type',
      orderStatus: 'Order Status',
      applicant: 'Applicant',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      edit: 'Edit',
      procurement: 'Procurement',
      audit: 'Audit'
    }
  },
  zh: {
    myAuditOrders: {
      todoList: '待办单',
      back: '返回',
      refresh: '刷新',
      orderNumber: '订单号',
      orderType: '订单类型',
      orderStatus: '订单状态',
      applicant: '申请人',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      edit: '修改',
      procurement: '采购入库',
      audit: '审批'
    }
  },
  'zh-TW': {
    myAuditOrders: {
      todoList: '待辦單',
      back: '返回',
      refresh: '刷新',
      orderNumber: '訂單號',
      orderType: '訂單類型',
      orderStatus: '訂單狀態',
      applicant: '申請人',
      createTime: '創建時間',
      operation: '操作',
      view: '查看',
      edit: '修改',
      procurement: '採購入庫',
      audit: '審批'
    }
  }
}
